/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch, SetStateAction, useCallback, useDebugValue, useState } from 'react';
import deepEqual from 'react-fast-compare';

function useLazyUpdateState<S>(initialState: S | (() => S)): [S, Dispatch<SetStateAction<S>>];
function useLazyUpdateState<S = undefined>(): [S | undefined, Dispatch<SetStateAction<S | undefined>>];

function useLazyUpdateState(defaultValue?: unknown): unknown {
  const [state, setState] = useState<unknown>(defaultValue);

  const setStateLazy = useCallback(
    (value: SetStateAction<unknown>) => {
      setState((curr: unknown) => {
        const newValue = typeof value === 'function' ? value(curr) : value;

        if (!deepEqual(curr, newValue))
          return newValue;
        else
          return curr;
      });
    },
    [],
  );

  useDebugValue(state);

  return [state, setStateLazy];
}

export default useLazyUpdateState;